// index.tsx
import React, {useEffect,useState,useRef} from "react";
import { Table } from "antd";
import {Link,useNavigate} from "react-router-dom";
import {DatatableProps} from "../interface/index";
// -- biz9 --
import {Message,Type,Config} from "../../constant";
import {Data,Toast_Message,App} from "../../project";
import {Log,Str,Num} from "biz9-utility";
import {Data_Logic} from "biz9-data-app";
import {Portal_Url,Portal_Remote_Data,Portal_Remote_CMS} from "biz9-portal-app";
/* -- biz9 import start -- */
const Datatable: React.FC<DatatableProps> = ({ allow_multiple,table,columns,dataSource,Selection,onUpdate,filter,sort_by,option,total,page_current,page_size }) => {
    const timeoutRef = useRef(null);
	const alert_prop = useRef(null);
    const [select_item_list, setSelectedRowKeys] = useState<any[]>([]);
    const [Selections, setSelections] = useState<any>(true);
    const [data_source, setDataSource] = useState(dataSource);
    const [val_total, setValTotal] = useState(total);
    const [val_filter, setValFilter] = useState(filter);
    const [val_page_current, setValPageCurrent] = useState(page_current);
    const [val_page_size, setValPageSize] = useState(Type.PAGE_SIZE);
     const [pagination, setPagination] = useState({
    current: page_current,
    pageSize: Type.PAGE_SIZE,
    total: total,
  });

   useEffect(() => {
        setDataSource(dataSource);
        setValPageCurrent(page_current);
        setValTotal(total);
        setValFilter(filter);
         setPagination({
        ...pagination,
        current: val_page_current,
        total: val_total,
      });
        return setSelections(Selection);
    }, [columns, dataSource,Selection,val_total,val_page_current,filter,sort_by])
    const onSelectChange = (newSelectedRowKeys) => {
        setSelectedRowKeys(newSelectedRowKeys);
    };
    const rowSelection = {
        select_item_list,
        onChange: (newSelectedRowKeys) => {
            setSelectedRowKeys(newSelectedRowKeys);
        },
        onSelectAll: (selected, selectedRows, changeRows) => {
            if (selected) {
                // If 'Select All' is checked, add all available row keys to selectedRowKeys
                const allRowKeys = data_source.map((record) => record.id); // Assuming 'dataSource' is your table data
                setSelectedRowKeys(allRowKeys);
            } else {
                // If 'Select All' is unchecked, clear all selectedRowKeys
                setSelectedRowKeys([]);
            }
        },
    };
    async function btn_post_delete(){
        // -- delete-items --
        if(window.confirm(Message.CONFIRM)) {
            let option = {};
            const [response,data] = await Portal_Remote_CMS.delete_ids(App.get_url(Portal_Url.CMS_DELETE_IDS),table,select_item_list,option);
            Log.w('11_response',response);
            Log.w('11_data',data);
            Log.w('11_selected_items',select_item_list);
            const new_data_source = dataSource.filter(item => !select_item_list.includes(item.id));
            setDataSource(new_data_source);
            //handleChange(new_data_source);
            setSelectedRowKeys([]);
            Toast_Message.success(response.message);
        }
        };

        const handleChange = (pagination, filters, sorter) => {
            Log.w('44_pagination',pagination);
            Log.w('44_filters',filters);
            Log.w('44_sorter',sorter);
        };

   //const handleChange = (new_list) => {
        //onUpdate(new_list); // Calls the parent's onUpdate function
    //};

        async function handlePageChange(page, filters, sorter){
            let sort_by = {};
            if(sorter.order == 'descend'){
                sort_by[sorter.field] = -1;
            }
            else if(sorter.order == 'ascend'){
                sort_by[sorter.field] = 1;
            }
            else{
               delete  sort_by[sorter.field];
            }
            const search = Data_Logic.get_search(table,filter,{sort_by:sort_by,page_current:page.current,page_size:page.pageSize});
            const [response,data] = await Portal_Remote_Data.search(App.get_url(Portal_Url.DATA_SEARCH),search,option);
           setValTotal(data.item_count);
            setValPageSize(Type.PAGE_SIZE);
            setValPageCurrent(page.current)
            setPagination({
                ...pagination,
                current: page.current,
                pageSize: page.pageSize,
                total:data.item_count
            });
            setDataSource(data.items);
            onUpdate(data.items);
        };
  return (
    <>
      <Table
      className="table datanew dataTable no-footer"
      rowSelection={allow_multiple?rowSelection:null}
      columns={columns}
      rowHoverable={false}
      rowKey={"id"}
      dataSource={data_source}
      onChange={handlePageChange}
      pagination={{
        locale: { items_per_page: "" },
        nextIcon: <i className="ti ti-chevron-right"/>,
        prevIcon: <i className="ti ti-chevron-left"/>,
        defaultPageSize: Type.TABLE_DEFAULT_SIZE,
        total:val_total,
        showSizeChanger: true,
        pageSizeOptions: ["10", "40", "60","100","200"],
        showTotal: (total, range) => `Showing ${range[0]} - ${range[1]} of ${total} entries`,
      }}
    />
        <div style={{paddingLeft:'20px'}} className="d-flex align-items-center pt-2 pb-2">
                  <Link onClick={btn_post_delete} hidden={select_item_list.length<=0} to="#" className="btn btn-primary">
            Delete {"("+select_item_list.length+")"}
            </Link>
            </div>
    </>
  );
};

export default Datatable;
